module.exports = __webpack_public_path__ + "static/media/membership-takeaway.21a68334.png";